import { render, staticRenderFns } from "./AlertMsg.vue?vue&type=template&id=415a002c&"
import script from "./AlertMsg.vue?vue&type=script&lang=js&"
export * from "./AlertMsg.vue?vue&type=script&lang=js&"
import style0 from "./AlertMsg.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports